(function() {
    'use strict';
    angular
        .module('tmgApp')
        .factory('ImportConstructel', ImportConstructel);

    ImportConstructel.$inject = ['$resource', 'DateUtils'];

    function ImportConstructel ($resource, DateUtils) {
        var resourceUrl =  'api/constructel-file/:id';

        return $resource(resourceUrl, {id: '@id'}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                        data.dateCreation = DateUtils.convertDateTimeFromServer(data.dateCreation);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' },
            'process': {
            	url:'api/constructel-file/:id/process',
            	method: 'PUT',
            	hasBody:false
            },
            'paid': {
            	url:'api/constructel-file/:id/paid',
            	method: 'PUT',
            	hasBody:false
            }
            ,'resetProcess': {
            	url:'api/constructel-file/resetProcess',
            	method: 'PUT'
            }
            ,'downloadURL':{
            	url:'api/constructel-file/:id/file',
            	method: 'GET',
            	hasBody:false
            },
            'saveNewFiles': {
                url:'api/constructel-file/new-files',
                method: 'POST',
                transformRequest: function (data) {
                    var copy = angular.copy(data);
                    return angular.toJson(copy);
                },
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
        });
    }
})();
